// extracted by mini-css-extract-plugin
export default {"clinicDetailsStatus":"clinicDetailsStatus_clinicDetailsStatus__n8Sss","closed":"clinicDetailsStatus_closed__51zgj","noClinicSelected":"clinicDetailsStatus_noClinicSelected__Rad5e"};